import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faCommentDots } from '@fortawesome/free-solid-svg-icons';


const PetWalker = () => {
    return (
        <div>
            {/* Header Section */}
            <div className="bg-tblue text-white p-4 rounded-t-lg">
                <h1 className="text-xl font-bold">Detailed Walk Information</h1>
            </div>

            {/* Main Content Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 bg-white p-6 rounded-b-lg shadow-lg border border-blue-300 min-h-full">
                {/* Left Section - Walker & Dog Profile */}
                <div className="col-span-2 space-y-6">
                    {/* Walker Profile */}
                    <div>
                        <h2 className="text-xl font-bold text-tblue mb-4">Walker Profile</h2>
                        <div className="flex items-center space-x-4">
                            <img
                                src="https://via.placeholder.com/50"
                                alt="Walker"
                                className="w-16 h-16 rounded-full"
                            />
                            <div>
                                <h3 className="text-tblue font-bold">Khalil Rehman</h3>
                                <p className="text-gray-500 text-sm">10 mins on the way</p>
                                <div className="flex space-x-2 mt-2">
                                    <button className="bg-tblue text-white p-2 rounded-full">
                                        <FontAwesomeIcon icon={faPhone} />
                                    </button>
                                    <button className="bg-tblue text-white p-2 rounded-full">
                                        <FontAwesomeIcon icon={faCommentDots} />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <p className="mt-4 text-gray-600">
                            This is a dummy text to show how the layout they have long ears with rounded tips and a short, dense coat.
                        </p>
                    </div>

                    {/* Dog Profile */}
                    <div>
                        <h2 className="text-xl font-bold text-tblue mb-4">Dog Profile</h2>
                        <div className="flex items-center space-x-4">
                            <img
                                src="https://via.placeholder.com/50"
                                alt="Dog"
                                className="w-16 h-16 rounded-full"
                            />
                            <div>
                                <h3 className="text-tblue font-bold">Hobo Brown</h3>
                                <p className="text-gray-500 text-sm">
                                    This is a dummy text to show how the layout they have long ears.
                                </p>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 gap-4 text-sm text-gray-600 mt-4">
                            <p><strong>Age:</strong> 2 years</p>
                            <p><strong>Color:</strong> Brown & White</p>
                            <p><strong>Gender:</strong> Male</p>
                            <p><strong>Start Time:</strong> 12:30 PM</p>
                            <p><strong>Vaccination:</strong> Yes</p>
                            <p><strong>Est. End Time:</strong> 2:30 PM</p>
                        </div>
                    </div>
                </div>

                {/* Middle Section - Map and Notes */}
                <div className="col-span-1 space-y-6">
                    {/* Live Map Section */}
                    <div>
                        <h2 className="text-xl font-bold text-tblue mb-4">Route Map: Live Tracking Map</h2>
                        <div className="bg-gray-100 rounded-lg h-40 flex items-center justify-center">
                            <p className="text-gray-500">[Map Placeholder]</p>
                        </div>
                    </div>

                    {/* Notes Section */}
                    <div>
                        <h2 className="text-xl font-bold text-tblue mb-4">Notes</h2>
                        <div className="bg-purple-100 p-4 rounded-lg max-w-md max-h-24 overflow-auto">
                            <p className="text-purple-700">
                                This is a dummy text to show how the layout they have long ears with rounded tips and a short, dense coat.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default PetWalker